// eslint-disable-next-line import/prefer-default-export
export const BedKpiKey = {
  TOTAL_BEDS: "total_beds",
  AVAILABLE_BEDS: "available_beds",
  OCCUPIED_BEDS: "occupied_beds",
  ADMITTED_TODAY: "admitted_today",
  DISCHARGED_TODAY: "discharged_today"
} as const;
